export function stravaAuth(){
    const url = "http://www.strava.com/oauth/authorize?client_id=54636&response_type=code&redirect_uri=https://leadingpace.net/admin/import&exchange_token&approval_prompt=force&scope=activity:read_all"
    window.open(url)                                                                                       
    
}




///https://leadingpace.net/admin/import_export
///http://localhost:3000/admin/import_export
///helper functions

export function splitUrl(url){
    var str1 = url.split("=")
    var str2 = str1[2]
    var str3 = str2.split("&")
    var str4 = str3[0]
    return (str4)
}